import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form-html5-validation";
import * as actions from "../../actions";
import {
    isRequiredSelection,
    isRequiredText,
    validateEmailSignup,
} from "../helpers/Validation";

class Step1 extends Component {
    render() {
        const { drp } = this.props;
        const { emailAddress } = this.props;
        const { selectedUser, takingNuplazid } = this.props.questionOptions;
        return (
            <Fragment>
                <div className="form-group">
                    <div className="grid">
                        <div className="row">
                            <div className="col-md-12">
                                <p>
                                    Sign up to receive additional information to
                                    help you or the person you care for stay
                                    informed. Our emails cover a variety of
                                    topics, including discussing symptoms with
                                    your healthcare provider, starting NUPLAZID,
                                    financial support, and more.
                                </p>
                            </div>
                        </div>
                        <Field
                            className="form-control full-width-input"
                            name="special"
                            component="input"
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input
                                        {...input}
                                        type="text"
                                        style={{ opacity: 0, height: "0px" }}
                                        tabIndex="-1"
                                    />
                                </Fragment>
                            )}
                        </Field>
                        <div className="row">
                            <div className="col-md-12">
                                <p className="font-15">
                                    <span className={"hang-left-7"}>*</span>
                                    Indicates required field.
                                </p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 margin-form">
                                <p className="font-15">
                                    Which statement best describes&nbsp;you?*
                                </p>
                                <div className="radio-field">
                                    <Field
                                        name="selectedUser"
                                        component="input"
                                        type="radio"
                                        value="caregiver"
                                        className="blue-bg-radio-btn"
                                        id="caregiver"
                                        onClick={(e) =>
                                            this.props.questionAnswer(
                                                "selectedUser",
                                                "caregiver"
                                            )
                                        }
                                    />
                                    <label className="" htmlFor="caregiver">
                                        I am a caregiver
                                    </label>
                                </div>
                                <div className="radio-field">
                                    <Field
                                        name="selectedUser"
                                        component="input"
                                        type="radio"
                                        value="patient"
                                        className="blue-bg-radio-btn"
                                        id="patient"
                                        onClick={(e) =>
                                            this.props.questionAnswer(
                                                "selectedUser",
                                                "patient"
                                            )
                                        }
                                    />
                                    <label className="" htmlFor="patient">
                                        I am a patient
                                    </label>
                                </div>
                                <Field
                                    name="selectedUser"
                                    component="input"
                                    defaultValue={selectedUser}
                                    validate={isRequiredSelection}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control full-width-input hidden-field"
                                                tabIndex="-1"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <div className="row spacer-medium mobile">
                                    &nbsp;
                                </div>
                            </div>
                            <div className="col-md-6 margin-form">
                                <p className="font-15">
                                    Are you or the person you care for taking
                                    NUPLAZID?*
                                </p>
                                <div className="radio-field">
                                    <Field
                                        name="takingNuplazid"
                                        component="input"
                                        className="blue-bg-radio-btn"
                                        type="radio"
                                        value="yes"
                                        id="yes"
                                        onClick={(e) =>
                                            this.props.questionAnswer(
                                                "takingNuplazid",
                                                "yes"
                                            )
                                        }
                                    />
                                    <label className="" htmlFor="yes">
                                        Yes
                                    </label>
                                </div>
                                <div className="radio-field">
                                    <Field
                                        name="takingNuplazid"
                                        component="input"
                                        className="blue-bg-radio-btn"
                                        type="radio"
                                        value="no"
                                        id="no"
                                        onClick={(e) =>
                                            this.props.questionAnswer(
                                                "takingNuplazid",
                                                "no"
                                            )
                                        }
                                    />
                                    <label className="" htmlFor="no">
                                        No
                                    </label>
                                </div>
                                <Field
                                    name="takingNuplazid"
                                    component="input"
                                    defaultValue={takingNuplazid}
                                    validate={isRequiredSelection}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control full-width-input hidden-field"
                                                tabIndex="-1"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                            </div>
                        </div>
                        <div className="row spacer-medium">&nbsp;</div>
                        <div className="row spacer-medium">&nbsp;</div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group relative">
                                    <Field
                                        className="form-control full-width-input"
                                        name="firstName"
                                        component="input"
                                        type="text"
                                        validate={isRequiredText}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="text-left full-width signup-label">
                                                    First Name*
                                                </label>
                                                <input
                                                    className={
                                                        meta.error &&
                                                        meta.touched
                                                            ? "form-control full-width-input signup-input error"
                                                            : "form-control full-width-input signup-input"
                                                    }
                                                    {...input}
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group relative">
                                    <Field
                                        className="form-control full-width-input"
                                        name="lastName"
                                        component="input"
                                        type="text"
                                        validate={isRequiredText}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="text-left full-width signup-label">
                                                    Last Name*
                                                </label>
                                                <input
                                                    className={
                                                        meta.error &&
                                                        meta.touched
                                                            ? "form-control full-width-input signup-input error"
                                                            : "form-control full-width-input signup-input"
                                                    }
                                                    {...input}
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>
                        <div className="row spacer-small">&nbsp;</div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group relative">
                                    <Field
                                        className="form-control full-width-input"
                                        name="emailAddress"
                                        component="input"
                                        type="text"
                                        defaultValue={emailAddress}
                                        validate={validateEmailSignup}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <label className="text-left full-width signup-label">
                                                    Email address*
                                                </label>
                                                <input
                                                    className={
                                                        meta.error &&
                                                        meta.touched
                                                            ? "form-control full-width-input signup-input error"
                                                            : "form-control full-width-input signup-input"
                                                    }
                                                    {...input}
                                                    placeholder="name@email.com"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
};

export default connect(mapStateToProps, actions)(Step1);
